import { render } from "./designCoding.vue?vue&type=template&id=3e5c429d"
import script from "./designCoding.vue?vue&type=script&lang=js"
export * from "./designCoding.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__